module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture36-8022c2c8753dbbc8eafdaadd78c05109.jpg";